import React, { FC, memo } from 'react';
import classNames from 'classnames';

type FeatureTheme = 'base' | 'warning' | 'accent' | 'error';

interface FeaturesListProps {
  features: string | string[];
  theme?: FeatureTheme;
  outlined?: boolean;
  className?: string;
  size?: 'sm' | 'md';
}

export const FeaturesList: FC<FeaturesListProps> = memo((props) => {
  const { features, theme = 'base', outlined = false, className = '', size = 'md' } = props;

  const featuresArray = Array.isArray(features) ? features : [features];

  const themeClasses = {
    base: outlined ? 'border-primaryLight text-primary bg-transparent' : 'bg-primaryLight text-primary border-primaryLight',
    warning: outlined ? 'border-warn text-warn bg-transparent' : 'bg-warn text-primary border-warn',
    accent: outlined ? 'border-accent text-accent bg-transparent' : 'bg-accent text-white border-accent',
    error: outlined ? 'border-error text-error bg-transparent' : 'bg-error text-white border-error',
  };

  const borderClass = outlined ? 'border' : 'border';

  return (
    <div className={classNames('flex flex-wrap gap-2', className)}>
      {featuresArray.map((feature, index) => (
        <span
          key={index}
          className={classNames(
            'inline-block font-medium px-4 py-2 rounded-full',
            borderClass,
            themeClasses[theme],
            size === 'sm' ? 'text-sm' : 'text-md',
          )}
        >
          {feature}
        </span>
      ))}
    </div>
  );
});
